export default __webpack_public_path__ + "static/media/bg-hr.e4f3b35f.png";